module.exports = __webpack_public_path__ + "media/images/icons/banda_invitada-53b0c5fc7315f68312a98f3ddafc8032.svg";